import React, {useState} from "react";
import {Collapse, Space, Typography} from "antd";
import {PlusOutlined} from "@ant-design/icons";
import TrendSettings from "./TrendSettings";
import {useStore} from "../../../../../../../../../../../hooks/useStore";
import {AddCommonTrendParameterConstraintsModal} from "./TrendSettings/AddCommonTrendParameterConstraintsModal";
import {observer} from "mobx-react-lite";

const {Panel} = Collapse;

const TrendSettingsCommon = observer(({trendCommonSettingsData}) => {
    const {commonTrendParameterConstraintsStore, accessStore} = useStore();

    const [isAddCommonTrendParameterConstraintsModalVisible, setIsAddCommonTrendParameterConstraintsModalVisible] = useState(false);
    const [settingsId, setSettingsId] = useState(null);
    const [groupId, setGroupId] = useState(null);

    const TREND_GROUPS = {
        1: "1 группа. Нестабильная работа, в том числе из-за повышенного газосодержания.",
        2: "2 группа. Снижение дебита, в том числе из-за увеличения ГФ.",
        3: "3 группа. Снижение или увеличение дебита из-за изменения Pпл и(или) PI.",
        4: "4 группа. Нестабильный режим работы УЭЦН, в том числе из-за мехпримесей и/или солеотложений на рабочих органах УЭЦН.",
        5: "5 группа. Снижение дебита, в том числе из-за мехпримесей и/или солеотложений на приеме УЭЦН.",
        6: "6 группа. Рост температуры ПЭД, в том числе из-за солеотложений на корпусе ПЭД.",
        7: "7 группа. Снижение дебита, в том числе из-за парафина.",
        8: "8 группа. Снижение дебита из-за негерметичности.",
        9: "9 группа. Отклонения на уровне ФА скважины."
    };

    const handleAddClick = async (settings, e) => {
        e.stopPropagation();

        await commonTrendParameterConstraintsStore.fetchParameters();
        setSettingsId(settings.id);
        setGroupId(settings.trendGroupName);
        setIsAddCommonTrendParameterConstraintsModalVisible(true);
    };

    return (
        <>
            {[...(trendCommonSettingsData || [])]
                .sort((a, b) => a.trendGroupName - b.trendGroupName)
                .map((settings) => (
                    <Collapse key={"trend-common-settings-collapse-" + settings.id} accordion ghost>
                        <Panel key={"trend-common-settings-panel-" + settings.id}
                               header={
                                   <div
                                       style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                                       <span>{TREND_GROUPS[settings.trendGroupName]}</span>
                                       {Boolean(accessStore.checkPermission("add_and_del_trend_analysis_settings")) &&
                                           <Space>
                                               <Typography.Link
                                                   onClick={(e) => handleAddClick(settings, e)}
                                               >
                                                   <PlusOutlined/>
                                               </Typography.Link>
                                           </Space>
                                       }
                                   </div>
                               }
                        >
                            <TrendSettings
                                warningData={settings}
                                warningId={settings.trendGroupName}
                            />
                        </Panel>
                    </Collapse>
                ))}

            <AddCommonTrendParameterConstraintsModal
                visible={isAddCommonTrendParameterConstraintsModalVisible}
                onSubmit={async (values) => {
                    const result = await commonTrendParameterConstraintsStore.addCommonTrendParameterConstraints(
                        groupId,
                        {
                            settingsId,
                            approxConstraints: [values.approxConstraints1, values.approxConstraints2],
                            sawConstraints: [values.sawConstraints1, values.sawConstraints2, values.sawConstraints3],
                            deltaValueConstraint: values.deltaValueConstraint,
                            parameterId: values.parameterId
                        });
                    if (result === true) {
                        setIsAddCommonTrendParameterConstraintsModalVisible(false)
                    }

                    return result;
                }}
                onCancel={() => setIsAddCommonTrendParameterConstraintsModalVisible(false)}
                fields={commonTrendParameterConstraintsStore.addCommonTrendParameterConstraintsFields}
            />
        </>
    );
});

export default TrendSettingsCommon;